import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

const ROTAS_LIVRES = ["minha-empresa", "valores-servicos",
  "config-fiscal", "calendario-fechamento", "condicoes"];

export const EmpresaOnboardingGate = () => {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (user?.role !== "empresa") return;
    api.get("/empresa/onboarding-status").then(r => setStatus(r.data)).catch(() => {});
    // eslint-disable-next-line
  }, [user, location.pathname]);

  useEffect(() => {
    if (!status || user?.role !== "empresa") return;
    const rota = location.pathname.replace(/^\/(admin|empresa)\/?/, "");
    if (!status.completo && !ROTAS_LIVRES.includes(rota)) {
      toast.info("Complete a ordem obrigatória: Dados & Nichos → Tabela de Valores → Fiscal → Calendário", { id: "onb-gate" });
      navigate("/empresa/minha-empresa", { replace: true });
      return;
    }
    const hoje = new Date().toISOString().slice(0, 10);
    if (status.completo && localStorage.getItem("mj_publicar_hint") !== hoje) {
      api.get("/empresa/condicoes-status").then(r => {
        if (r.data.pronto_para_publicar && !r.data.publicada) {
          localStorage.setItem("mj_publicar_hint", hoje);
          toast.info("Tudo pronto! Publique suas condições para a rede em Comercial → Publicar Condições", {
            id: "pub-hint", duration: 9000,
            action: { label: "Publicar", onClick: () => navigate("/empresa/condicoes") },
          });
        }
      }).catch(() => {});
    }
    // eslint-disable-next-line
  }, [status]);

  return null;
};
